import React, { ReactNode, SyntheticEvent } from 'react';
import styled from 'styled-components';

import { Icon } from 'components/Icon';
import { colors } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

const StyledCloseButton = styled(ButtonWithStyles)`
  padding: 8px 16px;
  color: ${colors.battleshipGrey};
  &:hover {
    color: ${colors.waterBlue};
    &:disabled {
      &:hover {
        color: ${colors.battleshipGrey};
      }
    }
  }
  background-color: transparent;
  border-radius: 0;
`;

type Props = {
  children?: ReactNode;
  'data-qa-id'?: string;
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void;
  onMouseDown?: (event: SyntheticEvent<HTMLButtonElement>) => void;
  className?: string;
};

export function CloseButton({ children, ...props }: Props) {
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledCloseButton p={0} {...props}>
      {children || (
        <Icon initialColorName="todo-replace-me" name="close" size={13} />
      )}
    </StyledCloseButton>
  );
}

export const ClearButton = styled(CloseButton)`
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  right: 17px;
  padding-left: 3px;
  padding-right: 3px;
`;
